import { useState } from 'react';

interface WarningsBannerProps {
  warnings: string[];
}

/** Surfaces adapter-level warnings (e.g. "nar: could not load ...") without blocking the rest of the UI. */
export function WarningsBanner({ warnings }: WarningsBannerProps) {
  const [dismissed, setDismissed] = useState(false);
  if (warnings.length === 0 || dismissed) return null;

  return (
    <div className="warnings-banner" role="status">
      <span>
        {warnings.length} data warning{warnings.length > 1 ? 's' : ''} this refresh (some sources may be incomplete).
      </span>
      <button type="button" onClick={() => setDismissed(true)}>
        Dismiss
      </button>
    </div>
  );
}
